<template>
  <router-link :to="{ name: 'bootcamp', params: { id: bootcamp.id } }">
    <div class="home-bootcamp">
      <div class="home-bootcamp__bootcamp-wrapper">
        <div class="home-bootcamp__bootcamp">
          <div
            class="home-bootcamp__wallpaper"
            :style="`background-image: url('${bootcampImage}');`"
          >
            <div class="home-bootcamp__instructors">
              <div
                class="home-bootcamp__instructors-profile-images--plus"
                v-if="moreThanThreeInstructors"
                v-tooltip="{
                  content: tooltipInstructorsNamesHtml,
                  classes: ['home-bootcamp__tooltip'],
                }"
              >
                +{{ this.lastInstructors.length }}
              </div>
              <div
                v-if="moreThanThreeInstructors"
                class="home-bootcamp__instructors-profile-images--plus-background"
              ></div>
              <div
                class="home-bootcamp__instructors-profile-images"
                v-for="(limitedInstructor, index) in limitedInstructors"
                :key="limitedInstructor.id"
                :style="instructorProfileImage(index)"
              >
                <img
                  :src="getInstructorImg(limitedInstructor)"
                  class="home-bootcamp__instructor-img"
                  :alt="getInstructorName(limitedInstructor)"
                />
              </div>
            </div>
          </div>
          <div class="home-bootcamp__information">
            <div class="home-bootcamp__actions">
              <div class="home-bootcamp__cta">
                <div
                  v-if="userRegistered"
                  class="home-bootcamp__registered-check home-bootcamp__registered-check"
                >
                  You're registered!
                </div>
              </div>
            </div>
            <div class="home-bootcamp__information-header">
              <h4 class="home-bootcamp__information-title">
                {{ bootcamp.name }}
              </h4>
              <h5 class="home-bootcamp__information-with-instructors">
                With {{ contentInstructors }}
              </h5>
            </div>
            <div class="home-bootcamp__information-description">
              {{ bootcamp.description }}
            </div>
            <div class="home-bootcamp__information-footer">
              <div class="home-bootcamp__information-date">
                {{ bootcampDate }}
              </div>
              <div class="home-bootcamp__information-area-wrapper">
                <div class="home-bootcamp__information-area">
                  <Passes :passName="learningAreaName" :size="24" laNoBorders />
                </div>
                <div class="home-bootcamp__information-area-name">
                  {{ learningAreaName }}
                </div>
              </div>
              <div class="home-bootcamp__information-footer-cta">
                <router-link
                  :to="{ name: 'bootcamp', params: { id: bootcamp.id } }"
                  class="btn btn--secondary home-bootcamp__information-footer-btn"
                  >See details
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="home-bootcamp__overlay"></div>
      </div>
    </div>
  </router-link>
</template>
<script>
import { bootcampCommons } from '@/helpers/mixins'
import Passes from '../../../properties/Passes.vue'

export default {
  name: 'HomeBootcamp',
  components: {
    Passes,
  },
  mixins: [bootcampCommons],
  props: {
    bootcamp: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    instructorProfileImage(index) {
      let offset = this.moreThanThreeInstructors ? -40 : 0
      let right = -25 - offset
      let measure = 40
      if (this.isMobile) {
        offset = offset < 0 ? -25 : 0
        right = -6 - offset
        measure = 30
      }
      return `right:${right + index * measure}px; z-index:${50 - index}`
    },
  },
  computed: {
    allInstructors() {
      return this.bootcamp.instructors
    },
    lastInstructors() {
      return this.moreThanThreeInstructors
        ? this.bootcamp.instructors.slice(3)
        : []
    },
    moreThanThreeInstructors() {
      return this.bootcamp.instructors.length > 3
    },
    tooltipInstructorsNamesHtml() {
      if (!this.moreThanThreeInstructors) return
      let instructorHtml = ''
      this.lastInstructors.forEach((instructor, i) => {
        instructorHtml +=
          i === this.lastInstructors.length - 1
            ? `<div>and ${instructor.name}</div>`
            : `<div>${instructor.name},</div>`
      })
      return instructorHtml
    },
    bootcampImage() {
      return (
        this.bootcamp.background_image_url ||
        require('@/assets/images/bootcamps/bootcamp_bg_small.png')
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.home-bootcamp {
  $this: &;
  position: relative;
  color: var(--white);
  height: 208px;
  background: var(--glass-mid-gray);
  border-radius: 10px;
  margin-bottom: 10px;
  display: flex;
  font-weight: normal;
  @include tablet {
    height: 255px;
  }
  &__wallpaper {
    @include mobile {
      flex: 0 0 200px;
    }
    flex: 0 0 116px;
    height: 100%;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
  }
  &__bootcamp {
    margin-bottom: 1em;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    z-index: 1;
    @include mobile {
      justify-content: flex-start;
    }
    @include tablet {
      flex-wrap: nowrap;
    }
    @include desktop {
      padding: 0;
    }
    &-wrapper {
      width: 100%;
    }
    &:hover {
      .home-bootcamp__information-footer-btn {
        border-color: var(--btn-hover-border-color) !important;
      }
    }
  }
  &__instructor-img {
    border-radius: 50%;
    max-height: 35px;
    @include mobile {
      max-height: 50px;
    }
    @include tablet {
      right: -50%;
    }
  }
  &__instructors {
    position: relative;
    &-profile-images {
      width: 35px;
      height: 35px;
      position: absolute;
      right: -6px;
      top: 9.78px;
      @include mobile {
        width: 50px;
        height: 50px;
        right: -32px;
        top: 22.22px;
      }
      &--plus {
        position: absolute;
        background: var(--glass-mid-gray);
        border: 1px solid var(--flat-black);
        border-radius: 50%;
        font-size: rem(12px);
        line-height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 35px;
        height: 35px;
        right: -6px;
        top: 9.78px;
        z-index: 60;
        @include mobile {
          font-size: rem(14px);
          width: 50px;
          height: 50px;
          right: -21px;
          top: 22.22px;
        }
        &-background {
          position: absolute;
          background: var(--dark-brighter);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 35px;
          height: 35px;
          z-index: 55;
          right: -6px;
          top: 9.78px;
          @include mobile {
            width: 50px;
            height: 50px;
            right: -21px;
            top: 22.22px;
          }
        }
      }
    }
  }

  &__information {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1 1;
    margin: 10px 10px 10px 15px;
    @include mobile {
      margin: 10px 10px 10px 35px;
    }
    @include tablet {
      margin: 20px 20px 23.5px 42px;
    }
    &-header {
      text-transform: capitalize;
      font-size: rem(16px);
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      flex-direction: column;
    }
    &-title {
      font-family: var(--font-medium);
      font-size: rem(12px);
      line-height: 14px;
      margin: 0 0 5px 0;
      @include mobile {
        font-size: rem(18px);
        line-height: 24px;
      }
    }
    &-description {
      color: var(--athens-gray);
      display: none;
      @include mobile {
        display: block;
      }
      font-size: rem(12px);
      line-height: 14px;
      margin: 0;
    }
    &-with-instructors {
      font-family: var(--font-medium);
      font-size: rem(10px);
      line-height: 12px;
      margin: 0 0 10px 0;
      @include mobile {
        font-size: rem(14px);
        line-height: 20px;
      }
    }
    &-footer {
      margin-top: auto;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      @include mobile {
        flex-direction: row;
        margin-bottom: 10px;
        align-items: center;
      }
      &-cta {
        width: 100%;
        @include mobile {
          margin-left: auto;
          width: initial;
        }
      }
      &-btn {
        width: 100%;
        font-size: rem(12px);
        padding: 8px 14px;
        height: 36px;
        @include mobile {
          font-size: rem(14px);
          width: initial;
          font-size: initial;
          height: 48px;
          padding: 12px 24px;
          height: 47px;
        }
      }
    }
    &-date {
      color: var(--purple-pale);
      line-height: 19px;
      margin-bottom: 5px;
      padding-right: 10px;
      font-size: rem(12px);
      line-height: 14px;
      @include mobile {
        border-right: 1px solid var(--perfect-gray);
        font-size: rem(14px);
        line-height: 20px;
        margin-bottom: 0;
      }
    }
    &-area-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 7.5px;
      @include mobile {
        margin-bottom: 0;
        margin-left: 7.5px;
      }
    }
    &-area {
      display: flex;
      align-items: center;
      line-height: 20px;
      &-name {
        font-size: rem(12px);
        line-height: 15px;
        margin-left: 4px;
        @include mobile {
          font-size: rem(14px);
          line-height: 20px;
        }
      }
    }
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    @include mobile {
      width: auto;
      display: block;
      margin-left: auto;
      position: absolute;
      right: 20px;
    }
  }
  &__cta {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  &__registered-check {
    padding: 5px 8px;
    font-size: rem(10px);
    line-height: 12px;
    border-radius: 30px;
    color: var(--charcoal);
    margin-bottom: 10px;
    background: var(--positive-light);
    box-shadow: 0px 0px 10px var(--chetwode-blue-50);
    @include mobile {
      font-size: rem(12px);
      line-height: 14px;
      margin-bottom: 0;
    }
  }
  &__overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background: var(--glass-extra-light);
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    opacity: 0;
    -webkit-backdrop-filter: saturate(100%) blur(6px);
    backdrop-filter: saturate(100%) blur(6px);
    transition: 0.2s all ease;
    border-radius: 10px;
  }
  &:hover {
    #{$this}__overlay {
      opacity: 1;
    }
  }
  &:active {
    #{$this}__overlay {
      background: var(--glass-dark);
      opacity: 1;
    }
  }
}
</style>
